import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

import { THREE_LETTER_TO_TWO_LETTER_LANG_CODES } from 'app/constants/LanguageConstants';
import { AUDIENCE, CONTENT_TYPE, FORMAT_ID, FULFILLMENT_PROVIDER } from 'app/constants/displayBib';

export default ImmutablePropTypes.mapContains({
  audience: PropTypes.oneOf(Object.values(AUDIENCE)).isRequired,
  authorNotes: PropTypes.bool.isRequired,
  availabilityStatus: PropTypes.oneOf(['AVAILABLE', 'ON_ORDER', 'UNAVAILABLE', 'UNKNOWN', '']).isRequired,
  content: PropTypes.oneOf(Object.values(CONTENT_TYPE)).isRequired,
  description: PropTypes.bool.isRequired,
  format: PropTypes.oneOf(Object.values(FORMAT_ID)).isRequired,
  groupKey: PropTypes.string.isRequired,
  language: PropTypes.oneOf(Object.keys(THREE_LETTER_TO_TWO_LETTER_LANG_CODES)).isRequired,
  manifestationsCount: PropTypes.number,
  metadataId: PropTypes.string.isRequired,
  provider: PropTypes.oneOf(Object.values(FULFILLMENT_PROVIDER)).isRequired,
  rating: PropTypes.number.isRequired,
  reviews: PropTypes.bool.isRequired
});
